import { Dispatch } from 'redux';

import {
  UserLocation,
  fetchUserLocation as apiFetchUserLocation,
} from 'api/userLocation';

// Types

export type MainStoreUserLocationState = UserLocation & {
  isFetching?: boolean;
  isLoaded?: boolean;
};

type FetchUserLocationRequestAction = {
  type: 'USER_LOCATION_FETCH_REQUEST';
};

type FetchUserLocationSuccessAction = {
  type: 'USER_LOCATION_FETCH_SUCCESS';
  userLocation: UserLocation;
};

export type MainStoreUserLocationAction =
  | FetchUserLocationRequestAction
  | FetchUserLocationSuccessAction;

// Reducer

export function userLocationReducer(
  // TODO: Fix this the next time the file is edited.
  // @ts-expect-error TS(2322): Type '{}' is not assignable to type 'MainStoreUser... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreUserLocationState = {},
  action: MainStoreUserLocationAction,
) {
  switch (action.type) {
    case 'USER_LOCATION_FETCH_REQUEST':
      return { ...state, isFetching: true };

    case 'USER_LOCATION_FETCH_SUCCESS':
      return { ...action.userLocation, isFetching: false, isLoaded: true };

    default:
      return state;
  }
}

// Actions

const fetchUserLocationRequest = (): FetchUserLocationRequestAction => ({
  type: 'USER_LOCATION_FETCH_REQUEST',
});

const fetchUserLocationSuccess = (
  userLocation: UserLocation,
): FetchUserLocationSuccessAction => ({
  type: 'USER_LOCATION_FETCH_SUCCESS',
  userLocation,
});

export const fetchUserLocation =
  () =>
  (
    dispatch: Dispatch<MainStoreUserLocationAction>,
    getState: () => { userLocation: MainStoreUserLocationState },
  ) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line prefer-destructuring
    const userLocation = getState().userLocation;

    if (userLocation.isFetching || userLocation.isLoaded) {
      return Promise.resolve() as Promise<void>;
    }

    dispatch(fetchUserLocationRequest());
    return apiFetchUserLocation().then((fetchedUserLocation) =>
      dispatch(fetchUserLocationSuccess(fetchedUserLocation)),
    );
  };
